<div class="grid">
<div class="col-12" *ngIf="showSelectAll">
  <p-inputSwitch [(ngModel)]="forceSelectAll" ></p-inputSwitch>
</div>
<div class="col-12">
<div #widthIdentifier id="folds_list">
  <p-table #pdt_fold_list class="foldsList" [tableStyleClass]="'fixtable'"
           (onRowSelect)="notifySelectedFolds($event)" (onRowUnselect)="notifySelectedFolds($event)"
           (onHeaderCheckboxToggle)="notifySelectedFolds($event)"
           (onPage)="updateCurrentPage($event)" (onColReorder)="handleChangeUserColOrder($event)" (onColResize)="handleChangeUserColSize($event)"
           [value]="folds" [columns]="columns" [rows]="DataTableFiller.NUMBER_OF_ROWS_FOR_SEARCH_RESULT_FOLDS"
           [resizableColumns]="true"
           [paginator]="true" [paginatorPosition]="'top'" [alwaysShowPaginator]="true"
           [pageLinks]="20" [showPageLinks]="true"
           [sortField]="sortField" [sortOrder]="defaultSortOrder" [metaKeySelection]="true" [(selection)]="selectedFolds"
           [selectionMode]="selectionType" [rowHover]="true"
           [reorderableColumns]="true" [resetPageOnSort]="false">
    <ng-template pTemplate="paginatorright">
      <div class="dirtyPositionFix" *ngIf="getnumberOfPages()">
        <input [max]="" pInputNumer type="number" [(ngModel)]="pageNumberAskedByUser" (change)="setNewPage()" [disabled]="noEntryInDataTable()" />
        <span>/{{getnumberOfPages()}}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="sorticon" let-sortOrder>
      <span *ngIf="sortOrder === 0"><i class="pi pi-fw pi-sort" aria-hidden="true"></i></span>
      <span *ngIf="sortOrder === 1"><i class="pi pi-fw pi-sort-up" aria-hidden="true"></i></span>
      <span *ngIf="sortOrder === -1"><i class="pi pi-fw pi-sort-down" aria-hidden="true"></i></span>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr id="boardHeader">
        <th>
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th *ngIf="showDiscardColumn" [style]="{'width': discardColumn.width + 'px'}" [pSortableColumn]="discardColumn.field" pResizableColumn>
          <div>
            <p-sortIcon [field]="discardColumn.field"></p-sortIcon> {{ discardColumn.header | translate }}
          </div>
        </th>
        <th *ngIf="showDelayedsenddate" [style]="{'width': delayedsenddate.width + 'px'}" [pSortableColumn]="delayedsenddate.field" pResizableColumn>
          <div>
            <p-sortIcon  [field]="delayedsenddate.field"></p-sortIcon>{{ delayedsenddate.header | translate }}
          </div>
        </th>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field" pResizableColumn>
          <div>
            <p-sortIcon  [field]="col.field"></p-sortIcon>{{ col.header | translate }}
          </div>
        </th>
      </tr>
      <tr>
        <!-- A discuter / proposer avec Mohamed / Kader
          <p-sortIcon [field]="col.field"></p-sortIcon>

          <th *ngIf="showDiscardColumn" field="discardColumn.field" [style]="{'width': discardColumn.width + 'px'}" pResizableColumn>
            <input pInputText type="text" (input)="pdt_fold_list.filter($event.target.value, discardColumn.field, discardColumn.filterMatchMode)">
          </th>
          <th *ngFor="let col of columns" pResizableColumn>
            <input pInputText type="text" (input)="pdt_fold_list.filter($event.target.value, col.field, col.filterMatchMode)">
          </th> -->
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group let-fold  let-columns="columns" let-row let-rowIndex="rowIndex" let-rowData>
      <tr [pSelectableRow]="rowData">
        <td class="p-resizable-column">
          <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
        </td>
        <!--<td *ngIf="showDiscardColumn" [style]="{'width': discardColumn.width + 'px'}"  class="p-resizable-column">
          <div *ngIf="row.sJustifaction" pTooltip="{{row.sNeutUser}} / {{row.sJustifaction}}" tooltipEvent="hover">
            {{row.sNeutUser}} / {{row.sJustifaction}}
          </div>
        </td>
        <td *ngIf="showDelayedsenddate" [style]="{'width': discardColumn.width + 'px'}"  class="p-resizable-column">
          <div >
            {{formatTimeStamp(row.delayedsenddate)}}
          </div>
        </td>-->

        <td *ngIf="showDiscardColumn" [style]="{'width': discardColumn.width + 'px'}"  class="p-resizable-column">
          {{fold.sNeutUser}} / {{ fold.sJustifaction }}
        </td>

        <td *ngIf="showDelayedsenddate" [style]="{'width': discardColumn.width + 'px'}"  class="p-resizable-column">
          {{formatTimeStamp(fold.delayedsenddate)}}
        </td>

        <td *ngFor="let col of columns" class="p-resizable-column">
          <ng-template [ngIf]="col.field === 'cfeStatusOrder'">
            <!-- [pTooltip]="fold.cfeStatusTitle" tooltipPosition="top" escape="false">-->
            <span class="block text-center" *ngIf="fold.cfeStatus">
                  <img data- class="cfeIcon" [pTooltip]="fold.cfeStatusTitle" [escape]="false" src="/assets/img/{{fold.cfeStatus}}.png" alt="">
            </span>
          </ng-template>
          <ng-template [ngIf]="col.field == 'motifpnd'">
            <span class="block text-center" [pTooltip]="fold.motifText" tooltipPosition="top">{{fold.motifText}}</span>
          </ng-template>
          <ng-template [ngIf]="col.field == 'status' && fold.status !== null && fold.status !== ''">
            <span class="block text-center"> {{ "SEARCH_COMPONENT.MAIL."+fold.status | translate }} </span>
          </ng-template>
          <ng-template [ngIf]="col.field === 'template' && fold.template !== null && fold.template !== ''">
            <span class="block text-center"> {{ getTemplateLabel(fold.template) }} </span>
          </ng-template>
          <ng-template [ngIf]="col.field !== 'cfeStatusOrder' && col.field !== 'motifpnd' && col.field !== 'status' && col.field !== 'template'">
            <span class="block text-center"> {{ group[ col.field ] }} </span>
          </ng-template>
        </td>
      </tr>
      <!--
          <ng-container *ngFor="let column of columns;">
              <p-column *ngIf="!column.width" [field]="column.field" sortable="true"
                        [header]="column.header | translate">
                <ng-template let-col let-row="rowData" pTemplate type="body">
                  <div *ngIf="col.field === 'sElectroArchivTrtID'" [pTooltip]="row.cfeStatusTitle" tooltipPosition="top"
                       [escape]="false">
                    <span *ngIf="row.cfeStatus"><img class="cfeIcon" src="/assets/img/{{row.cfeStatus}}.png"></span>
                  </div>
                  <div *ngIf="col.field !== 'sElectroArchivTrtID'">
                    {{row[col.field]}}
                  </div>
                </ng-template>
              </p-column>
            </ng-container>-->
    </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td *ngIf="!showDiscardColumn && !showDelayedsenddate" [attr.colspan]="columns.length + 1" class="p-resizable-column">
          {{ 'FOLDS.LIST_COMPONENT.EMPTY_MESSAGE' | translate }}
        </td>
        <td *ngIf="showDiscardColumn || showDelayedsenddate" [attr.colspan]="columns.length + 2" class="p-resizable-column">
          {{ 'FOLDS.LIST_COMPONENT.EMPTY_MESSAGE' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
</div>
</div>
